module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0041.jpg?v=147d6a2f";